import React, { useState, useRef } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import InmatesLogo1 from "../../Assets/Logos/InmatesLogo.png";
import InmatesLogo from "../../Assets/Logos/InmatesLogo.png";
import issuesLogo from "../../Assets/Logos/IssuesLogo.png";
import MoneyLogo from "../../Assets/Logos/MoneyLogo.png";
import WalletLogo from "../../Assets/Logos/Walletlogo.png";
import bedsOccupied from "../../Assets/Logos/bedsOccupied.png";
import noticesLogo from "../../Assets/Logos/noticesLogo.png";
import { useNavigate } from "react-router-dom";
import AddStaffForm from "../../components/AdminSideComponents/AddStaffForm";
import { MdAddCircle } from "react-icons/md";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";
import { useEffect } from "react";
import axios from "axios";
import EditStaffForm from "../../components/AdminSideComponents/EditStaffForm";
import RoleAssignModal from "../../components/AdminSideComponents/RoleAssignModal";

import deleteIcon from "../../Assets/Logos/checkout/deleteIcon.png";
import editIcon from "../../Assets/Logos/checkout/editIcon.png";
import setPermissionIcon from "../../Assets/Logos/checkout/greenRight.png";

const Staff = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [staffData, setStaffData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadStaffForm, setLoadStaffForm] = useState(false);
  const [EditStaff, setEditstaff] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const [pagination, setPagination] = useState({});
  const [load, setLoad] = useState(true);
  const [loadStaffRoleModal, setLoadStaffRoleModal] = useState(false);
  const navigate = useNavigate();
  const itemsPerPage = 10;
  const dropdownRefs = useRef([]);

  const [dropdownPosition, setDropdownPosition] = useState("down");

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 250 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  // const toggleDropdown = (index) => {
  //   setShowDropdown(showDropdown === index ? null : index);
  // };

  console.log("----->", staffData);
  // const filteredBookings = bookings.filter((booking) =>
  //   Object.values(booking).some((value) =>
  //     value.toLowerCase().includes(searchTerm.toLowerCase())
  //   )
  // );
  // Calculate total pages
  // const totalPages = Math.ceil(filteredBookings.length / itemsPerPage);

  // Get the current bookings for the current page
  // const currentBookings = filteredBookings.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  const getStaffByPage = (page) => {
    setLoad(true);
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/users/get_paginated_users_data?page=${page}&limit=${itemsPerPage}&search=${searchTerm}`,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setStaffData(response.data.users);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoad(false);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getStaffByPage(currentPage);
    }, 800); // Waits for 500ms of inactivity
    return () => clearTimeout(timeout);
  }, [currentPage, searchTerm, loadStaffRoleModal, loadStaffForm, EditStaff]);

  //Delete Staff By Id;
  const deleteStaff = (id) => {
    if (window.confirm("Are Sure you want to delete this staff ?")) {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/users/user_delete/${id}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          getStaffByPage(currentPage);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown !== null &&
        dropdownRefs.current[showDropdown] &&
        !dropdownRefs.current[showDropdown].contains(event.target)
      ) {
        setShowDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  // Navigate to the previous page
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Navigate to the next page
  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const clearSearch = () => {
    setSearchTerm("");
  };

  return (
    <div className="staffContainer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Staff
      </h1>
      {loadStaffForm ? (
        <AddStaffForm
          loadStaffForm={loadStaffForm}
          setLoadStaffForm={setLoadStaffForm}
        />
      ) : (
        ""
      )}

      {EditStaff ? (
        <EditStaffForm currentItem={currentItem} setEditstaff={setEditstaff} />
      ) : (
        ""
      )}

      {loadStaffRoleModal ? (
        <RoleAssignModal
          currentItem={currentItem}
          setLoadStaffRoleModal={setLoadStaffRoleModal}
        />
      ) : (
        ""
      )}
      <div className="p-4 bg-[#FFFFFF] mt-6 rounded-lg ">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px] sm:text-[24px] font-bold">Staff Lists</h1>
          <div className="flex items-center gap-1 lg:gap-2">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchTerm(e.target.value);
                }}
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-gray-700 focus:outline-none focus:ring focus:ring-blue-200"
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500" />
              {searchTerm && (
                <FaTimes
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                  onClick={clearSearch}
                />
              )}
            </div>

            <MdAddCircle
              onClick={() => {
                setLoadStaffForm(true);
              }}
              className="text-primaryColor rounded-lg cursor-pointer"
              size={40}
            />
          </div>
        </div>

        <div className="overflow-x-auto  min-h-[70vh]">
          <table className="w-[100rem] lg:w-full  bg-white  border-gray-200 rounded-md">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl  tracking-wide">
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Ph Number
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Email Id
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Joining Date
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Adhaar Number
                </th>

                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  User Type
                </th>
                {/* <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                Security Deposit
              </th>
              <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                Joining Date
              </th> */}
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {load ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                  </tr>
                ))
              ) : staffData?.length > 0 ? (
                staffData.map((booking, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.name}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.phoneNumber}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.email}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking?.joiningDate?.slice(0, 10)}
                    </td>
                    <td className="py-4 px-6 text-sm flex items-center gap-1 text-primaryTextColor">
                      {booking.adhaarNumber ? `${booking.adhaarNumber} ` : ""}
                      <img
                        src={setPermissionIcon}
                        className="h-4 w-4"
                        alt="setRole"
                      />{" "}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.userType}
                    </td>

                    <td className="py-4 px-6 text-sm hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                      {/* <div
                        className="relative "
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div className="z-30 absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg">
                            <ul className="py-1">
                              <li
                                onClick={() => {
                                  // navigate("/staff_role");
                                  setLoadStaffRoleModal(true);
                                  setCurrentItem(booking);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={setPermissionIcon}
                                  className="h-4 w-4"
                                  alt="setRole"
                                />{" "}
                                Set Role
                              </li>
                              <li
                                onClick={() => {
                                  setEditstaff(true);
                                  setCurrentItem(booking);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="edit"
                                />{" "}
                                Edit
                              </li>
                              <li
                                onClick={() => {
                                  deleteStaff(booking._id);
                                }}
                                className="text-gray-900 flex items-center gap-2 hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="delete"
                                />{" "}
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div> */}

                      <div
                        className="relative"
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div
                            className={`absolute ${
                              dropdownPosition === "up"
                                ? "bottom-full mb-2"
                                : "top-full mt-2"
                            } right-0 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-30`}
                          >
                            <ul className="py-1">
                              <li
                                onClick={() => {
                                  // navigate("/staff_role");
                                  setLoadStaffRoleModal(true);
                                  setCurrentItem(booking);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={setPermissionIcon}
                                  className="h-4 w-4"
                                  alt="setRole"
                                />{" "}
                                Set Role
                              </li>
                              <li
                                onClick={() => {
                                  setEditstaff(true);
                                  setCurrentItem(booking);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="edit"
                                />{" "}
                                Edit
                              </li>
                              <li
                                onClick={() => {
                                  deleteStaff(booking._id);
                                }}
                                className="text-gray-900 flex items-center gap-2 hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="delete"
                                />{" "}
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="py-28 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No Staffs available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalPages)} of{" "}
            {pagination.totalPages}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Staff;
